// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as DonutComponent} from './Donut.svg';

import Icon, { TIconProps } from '../Icon';

export const IconDonut = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <DonutComponent/>
  </Icon>
));
